import { RouteState } from "../ViewModel/RouteState";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";

function getFtlRoutesWithStates(
  states: Record<string, RouteState>,
  ftlRoutes: Array<FtlRouteViewModel>
) {
  if (!states) {
    return ftlRoutes;
  }

  const ftlRoutesCopy = [...ftlRoutes];

  Object.entries(states).forEach(([key, value]) => {
    const state = value;
    const ftlRoute = ftlRoutesCopy?.find(
      (item: FtlRouteViewModel) => item.RouteId === parseInt(key, 10)
    );
    if (ftlRoute) {
      ftlRoute.State = state;
    }
  });

  return ftlRoutesCopy;
}

export default getFtlRoutesWithStates;
